import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const TeamManagementTab = () => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const teamMembers = [
    {
      id: 1,
      name: "Kadiatou Bah",
      role: "Senior Developer",
      department: "Engineering",
      status: "active",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      email: "kadiatou.bah@ecomotech.com",
      phone: "+224 620 111 222",
      lastActive: "2 hours ago",
      currentProject: "Mobile App Redesign",
      workload: 85,
      performance: 92
    },
    {
      id: 2,
      name: "Ibrahima Camara",
      role: "Product Manager",
      department: "Product",
      status: "active",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      email: "ibrahima.camara@ecomotech.com",
      phone: "+224 621 222 333",
      lastActive: "30 minutes ago",
      currentProject: "Q4 Feature Planning",
      workload: 78,
      performance: 88
    },
    {
      id: 3,
      name: "Mariama Condé",
      role: "UX Designer",
      department: "Design",
      status: "on-leave",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      email: "mariama.conde@ecomotech.com",
      phone: "+224 622 333 444",
      lastActive: "2 days ago",
      currentProject: "User Research Study",
      workload: 0,
      performance: 95
    },
    {
      id: 4,
      name: "Sékou Keïta",
      role: "Backend Developer",
      department: "Engineering",
      status: "active",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      email: "sekou.keita@ecomotech.com",
      phone: "+224 623 444 555",
      lastActive: "1 hour ago",
      currentProject: "API Optimization",
      workload: 92,
      performance: 87
    },
    {
      id: 5,
      name: "Hawa Bangoura",
      role: "QA Engineer",
      department: "Quality Assurance",
      status: "active",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      email: "hawa.bangoura@ecomotech.com",
      phone: "+224 624 555 666",
      lastActive: "45 minutes ago",
      currentProject: "Automated Testing Suite",
      workload: 73,
      performance: 91
    },
    {
      id: 6,
      name: "Moussa Konaté",
      role: "DevOps Engineer",
      department: "Infrastructure",
      status: "active",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      email: "moussa.konate@ecomotech.com",
      phone: "+224 625 666 777",
      lastActive: "3 hours ago",
      currentProject: "Cloud Migration",
      workload: 88,
      performance: 89
    }
  ];

  const handleEmployeeSelect = (employeeId) => {
    setSelectedEmployees(prev => 
      prev?.includes(employeeId) 
        ? prev?.filter(id => id !== employeeId)
        : [...prev, employeeId]
    );
  };

  const handleBulkAction = (action) => {
    console.log(`Performing ${action} on employees:`, selectedEmployees);
    // Bulk action logic here
    setSelectedEmployees([]);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'bg-success/10 text-success';
      case 'on-leave': return 'bg-warning/10 text-warning';
      case 'inactive': return 'bg-error/10 text-error';
      default: return 'bg-muted/10 text-muted-foreground';
    }
  };

  const getWorkloadColor = (workload) => {
    if (workload >= 90) return 'text-error';
    if (workload >= 75) return 'text-warning';
    return 'text-success';
  };

  return (
    <div className="space-y-6">
      {/* Bulk Actions Bar */}
      {selectedEmployees?.length > 0 && (
        <div className="bg-primary/10 border border-primary/20 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">
              {selectedEmployees?.length} employee(s) selected
            </span>
            <div className="flex items-center space-x-2">
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => handleBulkAction('schedule')}
                iconName="Calendar"
                iconPosition="left"
              >
                Schedule Meeting
              </Button>
              <Button 
                variant="outline" 
                size="sm"
                onClick={() => handleBulkAction('assign')}
                iconName="UserPlus"
                iconPosition="left"
              >
                Assign Task
              </Button>
              <Button 
                variant="ghost" 
                size="sm"
                onClick={() => setSelectedEmployees([])}
                iconName="X"
              >
                Clear
              </Button>
            </div>
          </div>
        </div>
      )}
      {/* Team Members Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {teamMembers?.map((member) => (
          <div key={member?.id} className="bg-card border border-border rounded-lg p-6 card-shadow">
            {/* Employee Header */}
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  checked={selectedEmployees?.includes(member?.id)}
                  onChange={() => handleEmployeeSelect(member?.id)}
                  className="rounded border-border text-primary focus:ring-primary"
                />
                <div className="relative">
                  <img
                    src={member?.avatar}
                    alt={member?.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-card ${
                    member?.status === 'active' ? 'bg-success' : 'bg-muted'
                  }`} />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground">{member?.name}</h3>
                  <p className="text-sm text-muted-foreground">{member?.role}</p>
                </div>
              </div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(member?.status)}`}>
                {member?.status?.replace('-', ' ')}
              </span>
            </div>

            {/* Employee Details */}
            <div className="space-y-3 mb-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Department:</span>
                <span className="text-foreground">{member?.department}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Current Project:</span>
                <span className="text-foreground text-right">{member?.currentProject}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Workload:</span>
                <span className={`font-medium ${getWorkloadColor(member?.workload)}`}>
                  {member?.workload}%
                </span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Performance:</span>
                <span className="text-success font-medium">{member?.performance}%</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Last Active:</span>
                <span className="text-foreground">{member?.lastActive}</span>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="flex items-center space-x-2">
              <Button 
                variant="outline" 
                size="sm" 
                className="flex-1"
                iconName="MessageSquare"
                iconPosition="left"
              >
                Message
              </Button>
              <Button 
                variant="outline" 
                size="sm" 
                className="flex-1"
                iconName="Calendar"
                iconPosition="left"
              >
                Schedule
              </Button>
              <Button 
                variant="ghost" 
                size="sm"
                iconName="MoreHorizontal"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamManagementTab;